import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MarketingAgreeModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  overflow-y: auto;

  &.is-old-app-iphonex {
    padding-bottom: 30px;
  }

  .content {
    padding: 0 24px 24px;

    .checkbox {
      margin-bottom: 24px;

      .label {
        font-weight: 500;
      }
    }

    .desc {
      margin-bottom: 16px;
    }

    .agree-box {
      background: #f6f6f6;
      padding: 16px;
      margin-bottom: 30px;

      .channel-list {
        ${mixin.flex({})};
        gap: 16px;

        li {
          position: relative;
          width: 64px;
          font-size: 13px;
          line-height: 130%;
          padding-left: 8px;
          color: #ccc;

          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 7.5px;
            left: 0;
            width: 2px;
            height: 2px;
            background: #d9d9d9;
            border-radius: 50%;
          }

          &.sms {
            padding-left: 22.5px;

            &:before {
              left: 14.5px;
            }
          }
        }

        &.active li {
          color: #333;

          &:before {
            background: #333;
          }
        }
      }
    }

    .accordion-item .accordion-label {
      margin: 0;

      .label {
        font-size: 15px;
        line-height: 130%;
        padding: 0;

        .agree-title {
          font-weight: 500;
          font-size: 15px;
        }
      }
    }

    .agree-ctns {
      padding: 16px 0 6px;

      table {
        position: relative;
        font-size: 14px;
        line-height: 130%;
        border-top: 1px solid #000;
        margin-bottom: 30px;
        color: #333;

        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: #000;
        }

        th {
          height: 40px;
          font-weight: 500;
          border-bottom: 1px solid #e9e9e9;
        }

        td {
          height: 104px;
          font-weight: 500;
          padding: 12px 10px;
          vertical-align: top;

          + td {
            border-left: 1px solid #e9e9e9;
          }

          &.highlight {
            text-decoration: underline;
          }

          &.center {
            text-align: center;
            word-break: keep-all;
          }
        }
      }

      ul li {
        position: relative;
        font-size: 12px;
        line-height: 130%;
        padding-left: 9px;
        color: #777;

        span {
          text-decoration: underline;
          color: #333;
        }

        + li {
          margin-top: 6px;
        }

        &.highlight {
          font-weight: 500;
          font-size: 14px;
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          top: 8px;
          left: 0;
          width: 3px;
          height: 3px;
          background: #7b7b7b;
          border-radius: 50%;
        }
      }
    }
  }

  .modal-group-btn:after {
    display: none;
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      padding: ${mixin.pxToVw('0 24 24')};

      .checkbox {
        margin-bottom: ${mixin.pxToVw('24')};
      }

      .desc {
        margin-bottom: ${mixin.pxToVw('16')};
      }

      .agree-box {
        padding: ${mixin.pxToVw('16')};
        margin-bottom: ${mixin.pxToVw('30')};

        .channel-list {
          gap: ${mixin.pxToVw('16')};

          li {
            width: ${mixin.pxToVw('64')};
            font-size: ${mixin.pxToVw('13')};
            padding-left: ${mixin.pxToVw('8')};

            &:before {
              top: ${mixin.pxToVw('7.5')};
              width: ${mixin.pxToVw('2')};
              height: ${mixin.pxToVw('2')};
            }

            &.sms {
              padding-left: ${mixin.pxToVw('22.5')};

              &:before {
                left: ${mixin.pxToVw('14.5')};
              }
            }
          }
        }
      }

      .accordion-item .accordion-label {
        .label {
          font-size: ${mixin.pxToVw('15')};

          .agree-title {
            font-size: ${mixin.pxToVw('15')};
          }
        }
      }

      .agree-ctns {
        padding: ${mixin.pxToVw('16 0 6')};

        table {
          font-size: ${mixin.pxToVw('14')};
          margin-bottom: ${mixin.pxToVw('30')};

          th {
            height: ${mixin.pxToVw('40')};
          }

          td {
            height: ${mixin.pxToVw('104')};
            padding: ${mixin.pxToVw('12 10')};
          }
        }

        ul li {
          font-size: ${mixin.pxToVw('12')};
          padding-left: ${mixin.pxToVw('9')};

          + li {
            margin-top: ${mixin.pxToVw('6')};
          }

          &.highlight {
            font-size: ${mixin.pxToVw('14')};
          }

          &:after {
            top: ${mixin.pxToVw('8')};
            width: ${mixin.pxToVw('3')};
            height: ${mixin.pxToVw('3')};
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    border-radius: 0;
    width: 560px;

    .modal-title {
      position: relative;
      padding: 30px 52px 24px 32px;
      margin-bottom: 0;

      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 32px;
        width: calc(100% - 64px);
        height: 1px;
        background: #000;
      }

      .title {
        text-align: left;
        font-size: 24px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;
    }

    .content {
      padding: 32px;

      .checkbox {
        margin-bottom: 32px;
      }

      .desc {
        text-align: left;

        br {
          display: none;
        }
      }

      .agree-box {
        margin-bottom: 40px;

        .channel-list {
          justify-content: flex-start;

          li {
            font-size: 14px;
          }
        }
      }

      .agree-ctns {
        padding-bottom: 0;

        ul li {
          font-size: 14px;

          + li {
            margin-top: 12px;
          }

          br {
            display: none;
          }
        }
      }
    }

    .modal-group-btn {
      padding: 24px 87px;
    }
  }
`;
